import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Challenge", href: "#challenge" },
  { label: "Architecture", href: "#architecture" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Difference", href: "#difference" },
  { label: "Safety", href: "#safety" },
  { label: "Insights", href: "#insights" },
  { label: "Metrics", href: "#metrics" },
  { label: "Demo", href: "#demo" },
];

const scrollTo = (e, href) => {
  e.preventDefault();
  document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export const Header = ({ scrolled }) => {
  const [open, setOpen] = useState(false);

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
      scrolled ? "bg-white/90 backdrop-blur-xl border-b shadow-md" : "bg-transparent"
    )} style={{ borderColor: scrolled ? 'rgba(0,168,179,0.1)' : 'transparent' }}>
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 lg:h-[72px]">
          <a href="#home" onClick={(e) => scrollTo(e, "#home")} className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg logo-teal flex items-center justify-center">
              <span className="font-heading text-base font-bold text-white">C</span>
            </div>
            <span className="font-heading text-base font-semibold hidden sm:block" style={{ color: '#1A1F36' }}>CareContext&nbsp;Systems</span>
          </a>

          <nav className="hidden xl:flex items-center gap-1">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={(e) => scrollTo(e, l.href)}
                className="px-3 py-1.5 text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[rgba(0,168,179,0.08)]"
                style={{ color: '#6B7280' }}
                onMouseEnter={(e) => e.target.style.color = '#00A8B3'}
                onMouseLeave={(e) => e.target.style.color = '#6B7280'}>
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Button size="sm" className="btn-teal text-xs px-5" onClick={(e) => scrollTo(e, "#demo")}>Book&nbsp;Demo</Button>
            <button className="xl:hidden p-2" style={{ color: '#1A1F36' }} onClick={() => setOpen(!open)} aria-label="Menu">
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-white/98 backdrop-blur-lg border-b" style={{ borderColor: 'rgba(0,168,179,0.1)' }}>
          <nav className="max-w-7xl mx-auto px-6 py-3 flex flex-col gap-0.5">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={(e) => { scrollTo(e, l.href); setOpen(false); }}
                className="px-4 py-2.5 text-sm rounded-lg transition-colors hover:bg-[rgba(0,168,179,0.05)]" style={{ color: '#6B7280' }}>
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
